import React, {useState, useEffect, useRef, createRef } from "react";
import useMousetrap from "react-hook-mousetrap"
import axios from 'axios';
import AuthStore from '../../stores/AuthStore';
import ReactTooltip from 'react-tooltip'
import SpinnerLoader from '../Components/SpinnerLoader';

import {
  Badge,
  Card,
  Row,
  Col,
  Button,
  ButtonGroup,
  Label,
  Input,
  Table,
  TabContent,

  Collapse, ListGroup, ListGroupItem,
  TabPane,
  Nav, NavItem, NavLink
} from "reactstrap";

import Constants from '../../components/Constants';
import classnames from "classnames";


export default function DiagnosticSelect(props, history) {
	
	const [isLoading, setIsLoading] = useState(true);
	const [categories, setCategories] = useState({});
	const [currentCategory, setCurentCategory] = useState(0);
    const [preSelectedDiags, setPreSelectedDiags] = useState(props.preSelected != null ? props.preSelected : null);
    
    const categoryShortcuts = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
	const diagnosticShortcuts = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const categoriesRef = useRef(categoryShortcuts.map(() => createRef()));
    
    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
	useEffect(() => {
		
		axios({
			method: 'get',
			url: Constants.apiUrl+'/api/v1/category/full/1'
            //url: "diagnostics/diags_curto.json"
		})
		.then(response => {
            //let fullCategories = response.data;
            let fullCategories = response.data.sort(compareFullCategory);

            fullCategories.map((cat) => {
                cat.category.selected = false;
                cat.category.open = true;

                //seleciona diagnósticos  (prereported e reported)
                if(preSelectedDiags != null){
                    cat.diags.map((diag) => {
                        preSelectedDiags.map((preDiag) => {
                            if(diag.id == preDiag.id){
                                diag.selected = true;
                                cat.selected = true;
                            }
                        });
                    });
                }

            });

            setCategories(fullCategories);
            setIsLoading(false);
		});
	}, []);
	
	
	categoryShortcuts.map((shortcut, index) => {
		useMousetrap(shortcut, () => {
            let cats = categories;
            if(cats.length >= index){
                cats[index].category.open = true;
                setCurentCategory(index);
                setCategories(cats);
                
                scrollTo(categoriesRef.current[index]);
            }
		});
	});
	
	diagnosticShortcuts.map((shortcut, index) => {
		useMousetrap(shortcut, () => {
			if(currentCategory !== null && currentCategory >= 0){
				if(categories[currentCategory].diags[index] != null){
					selectDiag(categories[currentCategory].diags[index]);
				}
			}
		});
	});
    
	
	function compareFullCategory(a,b) {
      if (a.category.order < b.category.order)
        return -1;
      if (a.category.order > b.category.order)
        return 1;
      return 0;
    }
	
    function openCategory(categoryIndex){
        setCurentCategory(categoryIndex);
        let cats = categories;
        cats[categoryIndex].category.open = true;
        setCategories(cats);
        scrollTo(categoriesRef.current[categoryIndex]);
    }
    
     function closeCategory(categoryIndex){
        setCurentCategory(categoryIndex);
         
        let cats = categories;
        cats[categoryIndex].category.open = false;
        setCategories(cats);
    }
	
	function selectDiag(diagToSelect){
		let categoriesCopy = [...categories];
		categoriesCopy.map((cat) => {
			cat.selected = false;
			
			cat.diags.map((diag) => {
				if(diag.id == diagToSelect.id){
					diag.selected = (diag.selected == null) ? true : !diag.selected;
				}
				
				if(diag.selected){
					cat.selected = true;
				}
			});
		});
		
		setCategories(categoriesCopy);
		props.onReportChange(getReportDiagnostics(), createReportText());
	}
	
	function createReportText(){
		let reportText = "";
		categories.map((cat) => {
			cat.diags.map((diag) => {
				if(diag.selected){
					reportText = reportText + (reportText != "" ? ", " : "") + diag.description;
				}
			});
		});
		
		return reportText;
	}
	
	function getReportDiagnostics(){
		let diagnostics = [];
		categories.map((cat) => {
			cat.diags.map((diag) => {
				if(diag.selected){
					diagnostics.push(diag);
				}
			});
		});
		
		return diagnostics;
	}
    
    function resetDiagnostics(){
        categories.map((cat) => {
			cat.diags.map((diag) => {
				diag.selected = false;
			});
            cat.category.selected = false;
		});
        
        setCategories(categories);
        props.onReportChange(getReportDiagnostics(), createReportText());
    }
	
	return (
		<div className="h-100">
		{isLoading ? (
			<SpinnerLoader />
		) : (
         <div className="h-100">
            <div onClick={() => {resetDiagnostics()}} className="link-style mb-1">
                Limpar Selecionados
            </div>
             <div className="diagnostic-select-container">
                <ListGroup>
                {
                    categories.map( (cat, catIndex) => {
                        return  <ListGroupItem key={cat.category.id} onClick={() => {cat.category.open ? closeCategory(catIndex) : openCategory(catIndex);}} className="list-categories-item" >
                            {cat.selected ? <i className="fa fa-check-circle icon-diag-list text-success float-left"></i> : <i className="fa fa-check-circle icon-diag-list text-white float-left"></i>}
                            <span className={"ml-1 " + ((catIndex == currentCategory) ? "text-strong" : "")} ref={categoriesRef.current[catIndex]}>
                                [{categoryShortcuts.length > catIndex ? categoryShortcuts[catIndex] : "-"}]{" "}
                                {cat.category.description}
                            </span>
                            {cat.category.open ? <i className="fa fa-chevron-up float-right"></i> : <i className="fa fa-chevron-down float-right"></i>}

                            <Collapse isOpen={cat.category.open}>
                                <ListGroup className="list-diagnostics">
                                {
                                    cat.diags.map( (diag, diagIndex) => {
                                        return  <ListGroupItem key={diag.id} 
                                                    className={"list-diagnostics-item " + (diag.selected ? "selected" : "")} 
                                                    onClick={(evt) => {evt.stopPropagation();selectDiag(diag);}}>
                                                        <small>[{diagnosticShortcuts.length > diagIndex ? diagnosticShortcuts[diagIndex] : "-"}]</small>{diag.description}
                                        </ListGroupItem>
                                    })
                                }
                                </ListGroup>
                            </Collapse>
                        </ListGroupItem>
                    })
                }
                </ListGroup>
            </div>
        </div>
		)}
		</div>
	);
}




// WEBPACK FOOTER //
// ./src/views/DiagnosticSelect/DiagnosticSelect.js